import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BackButton } from 'components';
import { updateProviderBackupCodeService } from 'services/admin/providerService';
import BackupCodesProviderForm from 'components/admin/BackupCodesProviderForm';
import { Grid } from '@mui/material';

function EditErrorCodesRespaldoScreen() {
    const navigate = useNavigate();
    const { current, backupCodeSelected } = useSelector(store => store.providers)

    return (
        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                <div>
                    <BackButton click={() => navigate(-1)} />
                </div>
                <div className="container-title">
                    <div className="title">Proveedor</div>
                    <div className="subtitle">{current.container_name}</div>
                </div>
                <div style={{ width: "170px" }}></div>
            </Grid>
            <BackupCodesProviderForm
                defaultValues={{
                    code: backupCodeSelected.code,
                }}
                submit={(data) => {
                    updateProviderBackupCodeService(current.host, backupCodeSelected.id, data).then(() => {
                        navigate(-1);
                    }).catch((e) => {
                        console.log(e);
                        navigate(-1);
                    });
                }}
            />
        </>

    );
}

export default EditErrorCodesRespaldoScreen;